// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import mainSlider from './js/widgets/mainSlider.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import tier3Cards from './js/widgets/tier3Cards.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget1 from './js/widgets/videoWidget.js';
import tier5Cards from './js/widgets/tier5Cards.js';
import cardWidget4 from './js/widgets/cardGallery.js';
import socialTitle from './js/widgets/socialTitle.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
  if (globalThis.location.pathname === '/') {
    mainSlider();
    eventsWidget();
    tier3Cards();
    seoWidget();
    $(globalThis).on('load', function () {
      videoWidget1();
    });
    tier5Cards();
    cardWidget4();
    socialTitle();
    sponsors();
  }
});
